// Puts `text` (an emoji) where the cursor is in a text field and keeps the cursor after it.
// Returns the new value; the caller stores it in its own state.
export const insertAtCursor = (input, text) => {
  if (!input) return text;
  const {
    selectionStart = input.value.length,
    selectionEnd = input.value.length,
    value,
  } = input;
  const next =
    value.slice(0, selectionStart) + text + value.slice(selectionEnd);
  const cursor = selectionStart + text.length;
  requestAnimationFrame(() => {
    input.focus();
    input.setSelectionRange(cursor, cursor);
  });
  return next;
};
